import colors from './colors';

export default {
  color: {
    ...colors,
    primary: colors.blue,
    dark: colors.dark_gray,
    text: colors.dark_gray,
    light: colors.off_white,
    error: colors.red,
    success: colors.green,
  },
  easing: {
    default: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
  }
};
